import { render, staticRenderFns } from "./comp_handwerker.vue?vue&type=template&id=a29b2a3c&"
import script from "./comp_handwerker.vue?vue&type=script&lang=js&"
export * from "./comp_handwerker.vue?vue&type=script&lang=js&"
import style0 from "./comp_handwerker.vue?vue&type=style&index=0&id=a29b2a3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports